import * as React from "react"
import {Grid, Box} from "@mui/material";
import {CardSeeker, ModalSeeker} from "@ui-seeker/core";

import PricingEvolutionSkuBlock from "./SkuBlock";
import PricingSkuEvolutionChart from "./Chart";
import PricingSkuEvolutionViewDataSelect from "./ViewSelect";
import PricingSkuEvolutionKpiSelect from "./SkuBlock/KpiSelect";
import PricingSkuEvolutionDateSelect from "./SkuBlock/DatePeriodSelect";
import {usePriceDiscountEvolutionData} from "./@hooks";


export default function PricingMarketAnalyzerSkuEvolution() {
	const {
		isLoading, currentSkuSelected, data, currentSku, skusSelected, isViewTopRetailersData, currentFiveRetailers,
		viewData, handleViewData, currency, resetEvolutionSkuData, dateRange, onChange
	} = usePriceDiscountEvolutionData()

	if (!data.length || isLoading) return <></>

	return <ModalSeeker 
		hideActions 
		isOpen={!!data.length} 
		title={`Price Evolution - ${currentSkuSelected.sku}`} 
		controller={() => resetEvolutionSkuData()}
		containerProps={{
			maxWidth:"xl"
		}}
	>
		<CardSeeker title={<Box id='evolution-sku-chart'></Box>}>
			<Grid container spacing={2}>
				<Grid item xs={3}>
					<PricingEvolutionSkuBlock currentSku={currentSku} skusSelected={skusSelected} currentSkuSelected={currentSkuSelected} />
				</Grid>
				<Grid item xs={9}>
					<Grid container spacing={2} justifyContent={'center'}>
						<Grid item xs={4.5}>
							<PricingSkuEvolutionDateSelect dateRange={dateRange} onChange={onChange} />
						</Grid>

						<Grid item xs={2.5}>
							<PricingSkuEvolutionViewDataSelect viewData={viewData} onChange={handleViewData} />
						</Grid>

						<Grid item xs={2.5}>
							<PricingSkuEvolutionKpiSelect />
						</Grid>

						<Grid item xs={12}>
							<PricingSkuEvolutionChart
								data={data}
								isViewTopRetailersData={isViewTopRetailersData}
								currentFiveRetailers={currentFiveRetailers}
								currency={currency}
							/>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</CardSeeker>
	</ModalSeeker>
}
